/**
 * Maps agent names to their standard agent type IDs
 * This is needed because the backend returns agents with MongoDB IDs
 * and we need to map them by name to apply proper ordering
 */
export const AGENT_NAME_TO_TYPE: Record<string, string> = {
  // 1) Site Crawler Agent
  'Site Crawler Agent': 'site-crawler',
  'Site Crawler': 'site-crawler',
  
  // 2) Page Semantic Agent
  'Page Semantic Intent Agent': 'page-semantic-intent',
  'Page Semantics Learner': 'page-semantic-intent',
  'Page Semantic Agent': 'page-semantic-intent',
  
  // 3) Adjacent topics Explorer
  'Adjacent Topics Explorer': 'adjacent-topics',
  'Adjacent Topics Agent': 'adjacent-topics',
  
  // 4) Customer Intent Agent
  'Customer Intent Agent': 'customer-intent',
  'Customer Intent Learner': 'customer-intent',
  
  // 5) Page Chatbot Agent
  'Page Chatbot Agent': 'page-chatbot',
  'ChatBot': 'page-chatbot',
  'Chatbot': 'page-chatbot',
  
  // 6) Voice Assistant Agent
  'Voice Assistant Agent': 'voice-assistant',
  'VoiceBot': 'voice-assistant',
  'Voice Assistant': 'voice-assistant',
  
  // 7) Topic Research Agent
  'Topic Research Agent': 'topic-research',
  'Topic Research': 'topic-research',
  
  // 8) Analytics Insights Agent (aka Web Analyst)
  'Analytics Insight Agent': 'web-analyst',
  'Analytics Insights Agent': 'web-analyst',
  'Web Analyst': 'web-analyst',
  
  // 9) Competitors Analyst Agent
  'Competitors Analyst Agent': 'competitive-analysis',
  'Competitors Analyst': 'competitive-analysis',
  'Competitive Analysis Agent': 'competitive-analysis',
  
  // 10) Counter Narrative Builder
  'Counter Narrative Builder': 'counter-narrative',
  'Counter Narrative Agent': 'counter-narrative',
  
  // 11) Page Narrator
  'Page Narrator': 'narrative-presentation',
  'Narrative Presentation Agent': 'narrative-presentation',
  
  // 12) Hands off navigator
  'Hands-off Navigation': 'hands-off-navigation',
  'Hands-off Navigation Agent': 'hands-off-navigation',
  'Hands Off Navigator': 'hands-off-navigation',
  
  // 13) Product Comparison Agent
  'Product Comparison Agent': 'product-comparison',
  
  // 14) Question Suggester
  'Question Suggester': 'question-suggestion',
  'Question Suggestion Agent': 'question-suggestion',
  'Suggestions with Answer': 'question-suggestion',
  
  // 15) Know Your Customer Surveys Agent
  'Know Your Customer Surveys Agent': 'customer-surveys',
  'Customer Surveys Agent': 'customer-surveys',
  
  // 16) Replay analyst: friction finder
  'Replay Analyst: Friction Finder': 'replay-analyst',
  'Replay Analyst': 'replay-analyst',
  
  // 17) Behavior Analyst
  'Behavior Analyst': 'behavior-analyst',
  
  // 18) Sector Assigner
  'Sector Assigner': 'sector-assigner',
  'Site Sector Classifier': 'sector-assigner',
  
  // 19) Adjacent Topics Suggestor
  'Adjacent Topics Suggestor': 'adjacent-topics-suggestor',
  'Adjacent Topics Suggestor (to customer)': 'adjacent-topics-suggestor',
  
  // 20) Growth Analyst
  'Growth Analyst': 'growth-analyst',
  
  // Additional mappings for agents we see in the logs
  'Form Understanding Agent': 'form-understanding-agent',
  'Dynamic Interaction Agent': 'dynamic-interaction-agent',
  'Content Analysis Agent': 'content-analysis-agent',
  'Page Role Agent': 'page-role',
  'Task Execution Agent': 'task-execution-agent',
  'Marketing Optimization Agent': 'marketing-optimization-agent',
  'Decision Support Agent': 'decision-support-agent',
  'Multi-Page Analysis Agent': 'multi-page-analysis-agent',
  'Orchestration Agent': 'orchestration-agent',
  
  // Missing agents from Meet the Crew
  'Customer Segmentation Agent': 'customer-segmentation',
  'Segment Research Agent': 'segment-research',
  'Site Sector Analyzer': 'site-sector-analyzer',
  'Auto-evaluator Agent': 'auto-evaluator',
  'Insights Hub Agent': 'insights-hub',
  'Session Summarizer Agent': 'session-summarizer',
  'Style Suggestion Agent': 'style-suggestion',
  'Keyword Extractor Agent': 'keyword-extractor',
  'Intent-based Recommender': 'intent-based-recommender',
  
  // Chatbot Analytics Agents
  'Chatbot Intent Classifier': 'chatbot-intent-classifier',
  'Chatbot Quality Scorer': 'chatbot-quality-scorer',
  'Chatbot Content Gap Detector': 'chatbot-content-gap-detector',
  'Chatbot Conversation Flow Analyzer': 'chatbot-conversation-flow-analyzer',
  'Chatbot Analytics Orchestrator': 'chatbot-analytics-agent',
  'Chatbot Analytics Agent': 'chatbot-analytics-agent'
};